var render = function render() {
  var _vm$forwardedRequest, _vm$forwardedRequest2, _vm$forwardedRequest3, _vm$forwardedRequest5, _vm$forwardedRequest$, _vm$forwardedRequest6;
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-modal', {
    staticClass: "p-4",
    attrs: {
      "hide-header": "",
      "hide-footer": "",
      "centered": "",
      "no-close-on-backdrop": "",
      "no-stacking": "",
      "size": "lg"
    },
    model: {
      value: _vm.showDialog,
      callback: function ($$v) {
        _vm.showDialog = $$v;
      },
      expression: "showDialog"
    }
  }, [_c('b-row', {
    attrs: {
      "align-h": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "1"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "link"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "x-circle",
      "variant": "primary"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "tw-grid tw-grid-cols-3 tw-grid-rows-3"
  }, [_c('div', {
    staticClass: "tw-row-span-full"
  }, [_c('h4', [_vm._v("Forwarded Request")])]), _c('div', {
    staticClass: "tw-flex tw-flex-col gap-1"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Doctor")]), !_vm.isFetchingData ? _c('p', [_vm._v(" " + _vm._s((_vm$forwardedRequest = _vm.forwardedRequest) === null || _vm$forwardedRequest === void 0 ? void 0 : _vm$forwardedRequest.doctorname) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "tw-flex tw-flex-col gap-1"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Date")]), !_vm.isFetchingData ? _c('p', [_vm._v(" " + _vm._s(_vm.getDate((_vm$forwardedRequest2 = _vm.forwardedRequest) === null || _vm$forwardedRequest2 === void 0 ? void 0 : _vm$forwardedRequest2.timestampcreated)) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "tw-flex tw-flex-col gap-1"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Patient")]), !_vm.isFetchingData ? _c('p', [_vm._v(" " + _vm._s((_vm$forwardedRequest3 = _vm.forwardedRequest) === null || _vm$forwardedRequest3 === void 0 ? void 0 : _vm$forwardedRequest3.patientname) + " ")]) : _vm._e()]), _c('div', [_c('b-button', {
    attrs: {
      "variant": "primary",
      "pill": "",
      "size": "lg",
      "block": ""
    },
    on: {
      "click": function ($event) {
        var _vm$forwardedRequest4;
        return _vm.redirectToIntercom((_vm$forwardedRequest4 = _vm.forwardedRequest) === null || _vm$forwardedRequest4 === void 0 ? void 0 : _vm$forwardedRequest4.patientid);
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/intercom.svg"),
      "width": "120"
    }
  })])], 1), _c('div', {
    staticClass: "tw-flex tw-flex-col gap-1"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Doctor Notes")]), !_vm.isFetchingData ? _c('p', [_vm._v(" " + _vm._s((_vm$forwardedRequest5 = _vm.forwardedRequest) === null || _vm$forwardedRequest5 === void 0 ? void 0 : _vm$forwardedRequest5.doctornotes) + " ")]) : _vm._e()])]), _c('hr'), _c('div', {
    staticClass: "tw-bg-light-gray"
  }, [_vm.isFetchingData ? _c('div', {
    staticClass: "tw-w-full tw-grid tw-place-content-center"
  }, [_c('IconLoading')], 1) : [_c('ChatThread', {
    staticClass: "tw-w-full tw-h-[400px]",
    attrs: {
      "messages": (_vm$forwardedRequest$ = (_vm$forwardedRequest6 = _vm.forwardedRequest) === null || _vm$forwardedRequest6 === void 0 ? void 0 : _vm$forwardedRequest6.messagelist) !== null && _vm$forwardedRequest$ !== void 0 ? _vm$forwardedRequest$ : [],
      "date-resolver": _vm.chatThreadDateResolver
    },
    scopedSlots: _vm._u([{
      key: "bubble",
      fn: function ({
        message
      }) {
        return [_c('CorefrontChatBubble', {
          attrs: {
            "communication-role": _vm.getCommunicationRole(message),
            "avatar-url": _vm.profileUrlHashmaps[message.userid],
            "message": message.message,
            "sent-date-unix": Number(message.sentat),
            "attachments": message.attachment,
            "sender-name": _vm.namesHashmap[message.userid],
            "send-status": _vm.MESSAGE_SEND_STATUS.SENT,
            "bubble-background-class": _vm.getBubbleBackgroundClass(message),
            "hide-name": ""
          }
        })];
      }
    }])
  })]], 2), _c('div', {
    staticClass: "tw-mt-3"
  }, [_c('ComposerEditor', {
    ref: "composer",
    attrs: {
      "enable-send": false,
      "disable-file-upload": "",
      "tools": [_vm.TOOLS.BOLD, _vm.TOOLS.ITALIC, _vm.TOOLS.LINK]
    },
    on: {
      "send": _vm.sendReply
    },
    model: {
      value: _vm.reply,
      callback: function ($$v) {
        _vm.reply = $$v;
      },
      expression: "reply"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };